import React from "react";
import { Heading } from "../components/helpful";


export default class Video extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pageTitle: "Video",
      hotelImg: 0,
      desc: "Select your Video to download",
    };

    
  }
  subHeading = () => {
    return <>{this.state.desc}</>;
  }

  render() {
    return (
      <div>
        <div className="">
          <div>
            <Heading heading={this.state.pageTitle} Desc={this.subHeading} />
          </div>

          <div className="main-content">
          <p>
              You will be redirected to the Crowdriff platform, where you can
              view and download pictures and videos.{" "}
              <a
              target="_blank"
              rel="noreferrer"
                href="https://platform.crowdriff.com/m/beachcomber-resorts--hotels-"
                className=""
              >
                Click here
              </a>{" "}
              to be taken there.
            </p>
          </div>
        </div>
      </div>
    );
  }
}
